// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu-item[data-v-61f301ca],[data-v-61f301ca] .el-submenu__title {\n  height: 45px;\n  line-height: 45px;\n}\n[data-v-61f301ca] i:before {\n  color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
